import { Button, Input } from '@attentive-platform/stem-ui';

const CallbackSearchSection = ({ email, setEmail, onSearch, onAdd, searchLoading, canAdd }) => (
  <div className='flex flex-wrap gap-2 mb-4'>
    <Input
      className='min-w-[240px] flex-1'
      placeholder='User email'
      value={email}
      onChange={e => setEmail(e.target.value)}
    />
    <Button color='primary' variant='outlined' onClick={onSearch} loading={searchLoading}>
      Search
    </Button>
    <Button color='primary' variant='outlined' onClick={onAdd} disabled={!canAdd}>
      Add new callback
    </Button>
  </div>
);

export default CallbackSearchSection;
